import React from 'react';

import { Chip, Tooltip } from '@material-ui/core';
import { DeviceHub, Schedule, Autorenew } from '@material-ui/icons';

import stepsSolicitation from '../../domain/constant/steps.solicitation.constant';
import { isHeldByPromotionGate, linkHoldScheduledAtLabel, linkHoldTooltip } from '../../domain/link/link.hold';

const PRE_LINK_STATUSES = [stepsSolicitation.ANALYSE, stepsSolicitation.LINK];
const ICON_SIZE = 15;
const CHIP_BORDER_RADIUS = 3;
const CHIP_MARGIN_BOTTOM = 10;

const AUTOMATIC_LINK_BACKGROUND = '#376fd0';
const AUTOMATIC_LINK_LABEL = 'Vinculação automática';

const scheduleIcon = () => <Schedule style={{ width: ICON_SIZE, color: 'white' }} />;
const automaticLinkIcon = () => <DeviceHub style={{ width: ICON_SIZE, color: 'white' }} />;

const REROUTING_VARIANT = {
    label: 'Buscando o próximo profissional',
    tooltip: 'Um faciliter recusou este serviço e o sistema está buscando outro automaticamente.',
    background: '#D84315',
    icon: <Autorenew style={{ width: ICON_SIZE, color: 'white' }} />,
};

const AWAITING_FACILITER_VARIANT = {
    label: 'Aguardando faciliter disponível',
    tooltip: 'A pauta tentou vincular, mas não há faciliter disponível para este serviço no momento. Será vinculado assim que houver capacidade.',
    background: '#F9A825',
    icon: scheduleIcon(),
};

const AUTOMATIC_LINK_VARIANT = {
    label: AUTOMATIC_LINK_LABEL,
    tooltip: 'A pauta está processando este serviço e vai vinculá-lo automaticamente a um faciliter (por score e tier).',
    background: AUTOMATIC_LINK_BACKGROUND,
    icon: automaticLinkIcon(),
};

const scheduledDispatchVariant = (linkHold, scheduledAt) => ({
    label: `${AUTOMATIC_LINK_LABEL} ${scheduledAt}`,
    tooltip: linkHoldTooltip(linkHold),
    background: AUTOMATIC_LINK_BACKGROUND,
    icon: scheduleIcon(),
});

const heldWithoutScheduleVariant = (linkHold) => ({
    ...AUTOMATIC_LINK_VARIANT,
    tooltip: linkHoldTooltip(linkHold),
});

const getHeldVariant = (linkHold) => {

    if (!isHeldByPromotionGate(linkHold))
        return null;

    const scheduledAt = linkHoldScheduledAtLabel(linkHold);

    return scheduledAt ? scheduledDispatchVariant(linkHold, scheduledAt) : heldWithoutScheduleVariant(linkHold);
};

const getVariant = ({ isRerouting, awaitingFaciliter, linkHold }) => {

    if (isRerouting)
        return REROUTING_VARIANT;

    if (awaitingFaciliter)
        return AWAITING_FACILITER_VARIANT;

    return getHeldVariant(linkHold) || AUTOMATIC_LINK_VARIANT;
};

const AutoVinculoBadge = ({ status, awaitingFaciliter, isRerouting, linkHold }) => {

    if (!PRE_LINK_STATUSES.includes(status))
        return null;

    const variant = getVariant({ isRerouting, awaitingFaciliter, linkHold });

    return (
        <Tooltip title={variant.tooltip}>
            <Chip
                label={variant.label}
                size='small'
                icon={variant.icon}
                style={{
                    borderRadius: CHIP_BORDER_RADIUS, fontWeight: 'bold',
                    backgroundColor: variant.background, color: 'white',
                    padding: '0 5px', marginBottom: CHIP_MARGIN_BOTTOM
                }}
            />
        </Tooltip>
    );
};

export default AutoVinculoBadge;
